import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined'
import { makeStyles } from '@material-ui/styles'
import { useLocation } from 'react-router-dom'
import qs from 'query-string'

export const useStyles = makeStyles(theme => ({
  steps: {
    fontWeight: '500',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
}))

export default ({ previousUrl, stepText }) => {
  const classes = useStyles()
  const location = useLocation()
  const { returnTo } = qs.parse(location.search)
  const url =
    location.search.includes('returnTo') &&
    !location.search.includes('startDateTime')
      ? returnTo
      : previousUrl

  return (
    <Box display={{ xs: 'block', md: 'none' }}>
      <Grid item style={{ marginBottom: '36px', position: 'relative' }}>
        <Box display="flex" flexGrow={1}>
          <Button href={url} startIcon={<ArrowBackOutlinedIcon />}>
            BACK
          </Button>
        </Box>
        <Typography variant="body1" className={classes.steps}>
          {stepText}
        </Typography>
      </Grid>
    </Box>
  )
}
